module.exports = __webpack_public_path__ + "static/Inter-Bold-067214a91f0756bdf79a50f31b50d195.woff2";